import type { Mission } from '../missions.ts'

export const dot: Mission = {
  id: "dot",
  name: "U.S. Department of Transportation",
  short: "DOT",
  call: "Transportation",
  kind: "department",
  url: "https://www.transportation.gov/",
  established: 1966,
  palette: {
    primary: "#0071bc",
    secondary: "#47608c",
    accent: "#a8cf45",
  },
  colorSource: {
    kind: "site",
    url: "https://www.transportation.gov/",
  },
  motif: "swirl",
  mission: {
    text: "Advance safety. Move people and goods. Build big and beautiful infrastructure.",
    url: "https://www.transportation.gov/mission/about-dot",
  },
  fact: {
    text: "Created by an act signed in October 1966, the Department of Transportation began full operations on April 1, 1967.",
    url: "https://www.transportation.gov/50/creation-department-transportation-summary",
  },
  seal: {
    file: "public/seals/dot.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Transportation.svg",
  },
  identifier: {
    about: "https://www.transportation.gov/mission/about-dot",
    accessibility: "https://www.transportation.gov/mission/office-secretary/office-chief-digital-information-officer/digital-accessibility-statement",
    foia: "https://www.transportation.gov/foia",
    noFear: "https://www.transportation.gov/civil-rights/civil-rights-awareness-enforcement/no-fear-act",
    oig: "https://www.oig.dot.gov/",
    performance: "https://www.transportation.gov/dot-strategic-plan",
    privacy: "https://www.transportation.gov/dot-website-privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/dot-seven-mile-bridge.jpg",
        small: "/media/dot-seven-mile-bridge-sm.jpg",
        alt: "Aerial view of the Seven Mile Bridge and the older railroad bridge running side by side across turquoise water in the Florida Keys.",
        title: "Seven Mile Bridge, Florida Keys Scenic Highway, 2003",
        creator: "U.S. Department of Transportation",
        source: "https://commons.wikimedia.org/wiki/File:Seven_Mile_Bridge,_Florida_Keys_aerial_(2003).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/dot-castle-gate-rail.jpg",
        small: "/media/dot-castle-gate-rail-sm.jpg",
        alt: "A long freight train winding through a canyon between red and tan sandstone cliffs.",
        title: "Train passing through Castle Gate, Dinosaur Diamond Prehistoric Highway, Utah",
        creator: "A. E. Crane, U.S. Department of Transportation",
        source: "https://commons.wikimedia.org/wiki/File:Dinosaur_Diamond_Prehistoric_Highway_-_Train_Passing_through_Castle_Gate_-_NARA_-_7718038.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
